import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ThirdFlow from 'components/Flows/ThirdFlows/ThirdFlows';
import ThirdAnalysisDrawer from 'components/Analyses/ThirdAnalyses/Drawer/Drawer';

const ThirdFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <ThirdAnalysisDrawer />
      <ThirdFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ThirdFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);